// 跑马灯
export const goCarousel = function(id){
    let oDiv=document.getElementById(id);
    let oUl=oDiv.getElementsByTagName('ul')[0];
    let aLi=oUl.getElementsByTagName("li");
    let iSpeed=-1;
    let timer=null;
    // console.log(aLi,aLi.length)
    oUl.style.width=aLi[0].offsetWidth*aLi.length+'px';
    timer=setInterval(function(){
        oUl.style.left=oUl.offsetLeft+iSpeed+'px';
        // console.log(oUl.style.left)
        // console.log(oUl.offsetLeft,-oUl.offsetWidth/2)
        if(oUl.offsetLeft<-oUl.offsetWidth/2){
            oUl.style.left='10px';
        }
    },22);

    oUl.onmouseover=function(){
        clearInterval(timer);
    }

    oUl.onmouseout=function(){
        timer=setInterval(function(){
          var oUl=oDiv.getElementsByTagName('ul')[0];
            oUl.style.left=oUl.offsetLeft+iSpeed+'px';
            if(oUl.offsetLeft<-oUl.offsetWidth/2){
                oUl.style.left='10px';
            }
        },22);
    }
}

// export const rewriteLog =  function(){
//     console.log = (function (log) {
//         return process.env.NODE_ENV == 'development'? log : function() {}
//     }(console.log))
// }